import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';

import messages from 'messages';
import PageWithDrawer from '../../layouts/PageWithDrawer';
import { getUserStatus } from 'userUtils';
import { OrganizationList } from 'components/ListView/Lists/OrganizationList';

export const path = '/listview';

export const component = function ListView() {
  const intl = useIntl();
  const history = useHistory();
  const { keycloak } = useKeycloak();
  const userStatus = getUserStatus();
  const hasOrganizationAdminRole =
    keycloak.hasResourceRole('organizationAdmin');

  if (!hasOrganizationAdminRole && userStatus !== 'manager') {
    history.push('/');
    return <></>;
  }

  return (
    <PageWithDrawer title={intl.formatMessage(messages.home)}>
      <div align="right">
        <OrganizationList />
      </div>
    </PageWithDrawer>
  );
};
